// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactUsContainer {
  background-color: #172639;
  padding: 70px 100px 90px;
}

.contactHeading {
  color: #ffffff;
  font-weight: 800;
  font-size: 2.75rem;
  margin-bottom: 20px;
}

.contactSubheading {
  color: rgba(255, 255, 255, 0.75);
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 32px;
  max-width: 420px;
}

.contactDetails {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.contactDetailItem {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.contactDetailIcon {
  color: #eaa637;
  font-size: 18px;
  margin-top: 4px;
}

.contactDetailLabel {
  color: #eaa637;
  font-weight: 600;
  margin-bottom: 4px;
}

.contactDetailValue {
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
}

.contactFormCard {
  background-color: #ffffff;
  border-radius: 4px;
  padding: 40px;
}

.contactFormCard .form-label {
  color: #172639;
  font-weight: 700;
  font-size: 0.95rem;
}

.contactFormCard .form-control {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px 14px;
}

.contactFormCard .form-control:focus {
  border-color: #eaa637;
  box-shadow: 0 0 0 0.2rem rgba(234, 166, 39, 0.15);
}


@media (max-width: 992px) {
  .contactUsContainer {
    padding: 50px 24px 60px;
  }

  .contactHeading {
    font-size: 2.1rem;
  }

  .contactFormCard {
    padding: 28px;
  }
}

@media (max-width: 768px) {
  .contactHeading {
    font-size: 1.8rem;
  }

  .contactSubheading {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactUs.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;;AAGA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".contactUsContainer {\n  background-color: #172639;\n  padding: 70px 100px 90px;\n}\n\n.contactHeading {\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 2.75rem;\n  margin-bottom: 20px;\n}\n\n.contactSubheading {\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 1rem;\n  line-height: 1.7;\n  margin-bottom: 32px;\n  max-width: 420px;\n}\n\n.contactDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.contactDetailItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.contactDetailIcon {\n  color: #eaa637;\n  font-size: 18px;\n  margin-top: 4px;\n}\n\n.contactDetailLabel {\n  color: #eaa637;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.contactDetailValue {\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.5;\n}\n\n.contactFormCard {\n  background-color: #ffffff;\n  border-radius: 4px;\n  padding: 40px;\n}\n\n.contactFormCard .form-label {\n  color: #172639;\n  font-weight: 700;\n  font-size: 0.95rem;\n}\n\n.contactFormCard .form-control {\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  padding: 10px 14px;\n}\n\n.contactFormCard .form-control:focus {\n  border-color: #eaa637;\n  box-shadow: 0 0 0 0.2rem rgba(234, 166, 39, 0.15);\n}\n\n\n@media (max-width: 992px) {\n  .contactUsContainer {\n    padding: 50px 24px 60px;\n  }\n\n  .contactHeading {\n    font-size: 2.1rem;\n  }\n\n  .contactFormCard {\n    padding: 28px;\n  }\n}\n\n@media (max-width: 768px) {\n  .contactHeading {\n    font-size: 1.8rem;\n  }\n\n  .contactSubheading {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
